import { createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import shippoTheme from '../styles/shippoTheme.js';

const menuItemThemeInput = {
    components: {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: colors.hoverFocus,
                    },
                    '&.Mui-selected': {
                        backgroundColor: colors.accent.background.success,
                        '&:hover': {
                            backgroundColor: colors.hoverFocus,
                        },
                    },
                },
            },
        },
    },
};
var menuItemTheme = createTheme(shippoTheme, menuItemThemeInput);

export { menuItemTheme as default, menuItemThemeInput };
//# sourceMappingURL=MenuItem.theme.js.map
